<template>
	<div class="tutorial-step-success">
		<div class="tutorial-step-success__header">
			<div class="tutorial-step-success__icon">
				<img
					src="@/assets/images/tutorial/success-ring.svg"
					alt=""
					class="tutorial-step-success__ring"
				/>
				<img
					src="@/assets/images/tutorial/success-circle.svg"
					alt=""
					class="tutorial-step-success__circle"
				/>
				<img
					src="@/assets/images/tutorial/success-trophy.svg"
					alt=""
					class="tutorial-step-success__trophy"
				/>
			</div>
			<div class="tutorial-step-success__content">
				<div class="tutorial-step-success__title">
					{{ title || 'Tuyệt vời!' }}
				</div>
				<div class="tutorial-step-success__text">
					{{
						message ||
						'Bạn đã hoàn thành một bước quan trọng để bắt đầu sử dụng Luca Education. Hãy tiếp tục khám phá các tính năng tiếp theo để làm quen với hệ thống.'
					}}
				</div>
			</div>
		</div>
		<div class="tutorial-step-success__actions">
			<button
				type="button"
				class="tutorial-step-success__secondary"
				@click="$emit('pause')"
			>
				{{ pauseLabel || 'Tạm dừng' }}
			</button>
			<button
				type="button"
				class="tutorial-step-success__primary"
				@click="$emit('continue')"
			>
				{{ confirmLabel || 'Tiếp tục' }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TutorialStepSuccessModal',
	emits: ['pause', 'continue'],
	props: {
		message: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: '',
		},
		pauseLabel: {
			type: String,
			default: '',
		},
		confirmLabel: {
			type: String,
			default: '',
		},
	},
};
</script>

<style scoped>
.tutorial-step-success {
	width: 600px;
	max-width: calc(100vw - 32px);
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.1), 0 20px 24px rgba(20, 37, 63, 0.06);
}
.tutorial-step-success__header {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	padding: 24px 48px;
	background: #fff;
}
.tutorial-step-success__icon {
	position: relative;
	width: 60px;
	height: 60px;
	flex-shrink: 0;
}
.tutorial-step-success__ring {
	position: absolute;
	top: 0;
	left: 0;
	width: 59.61px;
	height: 60px;
}
.tutorial-step-success__circle {
	position: absolute;
	top: 7.1px;
	left: 7.05px;
	width: 45.5px;
	height: 45.8px;
}
.tutorial-step-success__trophy {
	position: absolute;
	top: 17.5px;
	left: 19.3px;
	width: 21px;
	height: 21px;
}
.tutorial-step-success__content {
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
	text-align: center;
}
.tutorial-step-success__title {
	font-size: 20px;
	line-height: 28px;
	font-weight: 600;
	color: #344256;
}
.tutorial-step-success__text {
	font-size: 16px;
	line-height: 24px;
	color: #65758b;
}
.tutorial-step-success__actions {
	display: flex;
	gap: 24px;
	padding: 24px 48px;
	background: #f8fafc;
}
.tutorial-step-success__secondary,
.tutorial-step-success__primary {
	flex: 1;
	min-width: 0;
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
	text-align: center;
}
.tutorial-step-success__secondary {
	padding: 12px 18px;
	border-radius: 5px;
	color: #65758b;
}
.tutorial-step-success__primary {
	padding: 12px 20px;
	border-radius: 4px;
	background: #f0bb4f;
	color: #344256;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.24), 0 3px 8px rgba(50, 50, 71, 0.05);
}
</style>
